module.exports = __webpack_public_path__ + "img/step_2.26103ce3.png";